import { Assets } from "../../../../utils/Assets";
import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

export const formHelpConfig: Record<string, string> = {
  text: "topic.help",
  image: Assets.topicPreview,
};

export const statusOptions: Record<string, string> = {
  draft: "topic.status.draft",
  available: "topic.status.available",
  unavailable: "topic.status.unavailable",
};

export const levelOptions: Record<string, string> = {
  all: "topic.level.all",
  beginner: "topic.level.beginner",
  intermediate: "topic.level.intermediate",
  advanced: "topic.level.advanced",
};

const topicFormConfig = (
  categoryOptions: Record<string, string>,
  topicOptions: Record<string, string>,
): FormConfig[] => [
    {
      name: "title",
      label: "topic.field.title",
      placeholder: "topic.field.titlePlaceholder",
      type: FormFieldType.Text,
    },
    {
      name: "description",
      label: "topic.field.description",
      placeholder: "topic.field.descriptionPlaceholder",
      type: FormFieldType.Textarea,
    },
    {
      name: "categoryId",
      label: "topic.field.category",
      placeholder: "topic.field.categoryPlaceholder",
      type: FormFieldType.Select,
      settings: {
        options: categoryOptions,
        nullOption: true,
      },
    },
    {
      name: "image",
      label: "topic.field.image",
      placeholder: "topic.field.image",
      type: FormFieldType.Image,
      settings: {
        format: 1,
      },
    },
    {
      name: "introduction",
      label: "topic.field.introduction",
      placeholder: "topic.field.introductionPlaceholder",
      type: FormFieldType.RichText,
    },
    {
      name: "goals",
      label: "topic.field.goals",
      placeholder: "topic.field.goalsPlaceholder",
      type: FormFieldType.List,
    },
    {
      name: "synthesis",
      label: "topic.field.synthesis",
      placeholder: "topic.field.synthesisPlaceholder",
      type: FormFieldType.RichText,
    },
    {
      name: "conclusion",
      label: "topic.field.conclusion",
      placeholder: "topic.field.conclusionPlaceholder",
      type: FormFieldType.RichText,
    },
    {
      name: "tags",
      label: "topic.field.tags",
      placeholder: "topic.field.tagsPlaceholder",
      type: FormFieldType.List,
      settings: { hideForViewer: true },
    },
    {
      name: "keywords",
      label: "topic.field.keywords",
      placeholder: "topic.field.keywordsPlaceholder",
      type: FormFieldType.CompactList,
      settings: { hideForViewer: true },
    },
    {
      name: "level",
      label: "topic.field.level",
      placeholder: "topic.field.levelPlaceholder",
      type: FormFieldType.Select,
      settings: {
        options: levelOptions,
        hideForViewer: true,
      },
    },
    {
      name: "status",
      label: "topic.field.status",
      placeholder: "topic.field.statusPlaceholder",
      type: FormFieldType.Select,
      settings: {
        options: statusOptions,
        hideForViewer: true,
      },
    },
    {
      name: "relatedTopicIds",
      label: "topic.field.relatedTopics",
      placeholder: "topic.field.relatedTopicsPlaceholder",
      type: FormFieldType.MultiSelect,
      settings: {
        options: topicOptions,
      },
    },
    {
      name: "comments",
      label: "topic.field.comments",
      placeholder: "topic.field.commentsPlaceholder",
      type: FormFieldType.Textarea,
    },
  ];

export default topicFormConfig;
